<div class="popup modal-header w-100 d-inline-block p-4 pb-0 mb-0">
    <div *ngIf="!requestSent">
      <div class="text-right w-100" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div>
      <h1>Resend Booking Confirmation?</h1>
      <p class="mb-5">Are you sure you want to request for <span class="fw-bold">booking confirmation?</span>
      </p>
      <div class="mb-4 d-flex  gap-3 resend">
        <button class="btn btn-stripe " (click)="bsModalRef?.hide()" >No</button>
        <button class="btn btn-resend " (click)="resend()">Resend Booking</button>
      </div>
    </div>
  
    <div *ngIf="requestSent" class="p-4">
      <div class="text-right w-100" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div>
      <img src="assets/images/Success.gif" class="success">
  
      <h1>Request Sent!</h1>
      <p class="mb-5">Your booking confirmation receipt has been sent successfully.
      </p>
      <div class="mb-4 d-flex  gap-3 resend">
        <button class="btn btn-resend w-100 " (click)="bsModalRef?.hide()">Done</button>
      </div>
    </div>
  </div>